import { NgModule } from '@angular/core';
import { EpBtJourneyPlannerProxyComponent } from './ep-bt-journey-planner-proxy.component';

@NgModule({
  declarations: [EpBtJourneyPlannerProxyComponent],
  imports: [
  ],
  exports: [EpBtJourneyPlannerProxyComponent]
})
export class EpBtJourneyPlannerProxyModule { }
